import { FC } from 'react';
import { useSelector } from 'react-redux';

import { userDataSelector } from '@store/features/auth/user/selectors';
import useAthleteSports from '@store/hooks/useAthleteSports';

import UserProfileModalAdmin from './UserProfileModalAdmin/UserProfileModalAdmin';
import UserProfileModalInitial from './UserProfileModalInitial/UserProfileModalInitial';
import UserProfileModalNormal from './UserProfileModalNormal/UserProfileModalNormal';
import { IUserProfileModalProps } from './UserProfileModal.interface';

const UserProfileModal: FC<IUserProfileModalProps> = ({ open, onClose }) => {
  const user = useSelector(userDataSelector);
  const athleteSports = useAthleteSports();
  const isDataReady = user && (athleteSports.length || !user.showSports);

  if (user?.isAdmin) return <UserProfileModalAdmin open={open} onClose={onClose} />;
  if (user?.organizationId && isDataReady)
    return <UserProfileModalNormal onClose={onClose} open={open} />;
  return <UserProfileModalInitial open={open} />;
};

export default UserProfileModal;
